import React from 'react';
import PropTypes from 'prop-types';

import { Text } from '../../../../../components';

const AnswerSummary = ({ text }) => (
  <Text $small $color='var(--content-subtitle)'>
    {text}
  </Text>
);

AnswerSummary.propTypes = {
  text: PropTypes.string.isRequired
};

export { AnswerSummary };
